module.exports = __webpack_public_path__ + "static/img/coal@2x.330b1ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/coal@2x.png
// module id = hIRd
// module chunks = 44